import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Layout from "./components/site/Layout";
import Home from "./pages/Home";
import About from "./pages/About";
import Branches from "./pages/Branches";
import BranchDetail from "./pages/BranchDetail";
import Courses from "./pages/Courses";
import Events from "./pages/Events";
import EventDetail from "./pages/EventDetail";
import CoachApply from "./pages/CoachApply";
import Gallery from "./pages/Gallery";
import News from "./pages/News";
import Contact from "./pages/Contact";

import { AuthProvider } from "./admin/AuthContext";
import ProtectedRoute from "./admin/ProtectedRoute";
import AdminLogin from "./admin/AdminLogin";
import AdminDashboard from "./admin/AdminDashboard";

import GoodPT from "./pages/goodpt/GoodPT";
import Nutrition from "./pages/goodpt/Nutrition";
import NazanNutrition from "./pages/goodpt/NazanNutrition";
import YagmurPlan from "./pages/goodpt/YagmurPlan";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App dark">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Routes>
            {/* Admin (no public layout) */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />

            {/* GoodPT — personal training plan (no main site header) */}
            <Route path="/goodpt" element={<GoodPT />} />
            <Route path="/goodpt/beslenme" element={<Nutrition />} />
            <Route path="/nazan" element={<NazanNutrition />} />
            <Route path="/yagmur" element={<YagmurPlan />} />

            {/* Public site */}
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/hakkimizda" element={<About />} />
              <Route path="/branslar" element={<Branches />} />
              <Route path="/branslar/:slug" element={<BranchDetail />} />
              <Route path="/kurslar" element={<Courses />} />
              <Route path="/etkinlikler" element={<Events />} />
              <Route path="/etkinlikler/:id" element={<EventDetail />} />
              <Route path="/antrenor-basvuru" element={<CoachApply />} />
              <Route path="/galeri" element={<Gallery />} />
              <Route path="/duyurular" element={<News />} />
              <Route path="/iletisim" element={<Contact />} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="top-center"
        theme="dark"
        toastOptions={{
          style: {
            background: "hsl(218 45% 11%)",
            color: "white",
            border: "1px solid hsl(202 100% 50% / 0.4)",
          },
        }}
      />
    </div>
  );
}

export default App;
